import * as React from "react";


function LoginComponent(props) {

    return (
        <>

            <div className= "container">
                <div className= "knowledgeBody">
                    <div className= "title">
                        <h1 data-selectable-paragraph="">
                        <strong className="ce">ERROR: Access from your IP address has been blocked for security reasons.<br/> Please contact the administrator.</strong>
                        </h1>
                    </div>
                </div>
            </div>
        </>
        
    );
}

export default LoginComponent;